import { useEffect, useState } from 'react';

import { type WebSocketMessage, type WebSocketMessageTypes } from '../../models/index.js';
import useWebSocket from '../../providers/useWebSocket.js';

const useWebSocketMessage = <T>(event: WebSocketMessageTypes) => {
  const [message, setMessage] = useState<WebSocketMessage<T>>();
  const {lastMessage} = useWebSocket<T>();
  useEffect(() => {
    if (lastMessage?.event === event){
      return setMessage(lastMessage);
    }
  }, [lastMessage, event]);
  return message;
};

export default useWebSocketMessage;
